"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _DesignComponents = require("../DesignComponents/DesignComponents");
require("./ModalFeedback.scss");
var _CompletionStatusContext = _interopRequireDefault(require("../CompletionStatusContext"));
var ModalFeedback = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ModalFeedback, _Component);
  var _super = (0, _createSuper2.default)(ModalFeedback);
  function ModalFeedback() {
    (0, _classCallCheck2.default)(this, ModalFeedback);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(ModalFeedback, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops) {
      if (prevprops.show !== this.props.show) {
        if (this.props.show) {
          this.timeShowed = new Date();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$correct,
        _this$props$incorrect,
        _this$props$title,
        _this = this;
      var correct = (_this$props$correct = this.props.correct) !== null && _this$props$correct !== void 0 ? _this$props$correct : !((_this$props$incorrect = this.props.incorrect) !== null && _this$props$incorrect !== void 0 ? _this$props$incorrect : true);
      var info = this.props.correct === undefined && this.props.incorrect === undefined;
      return /*#__PURE__*/_react.default.createElement(_DesignComponents.Modal, {
        title: (_this$props$title = this.props.title) !== null && _this$props$title !== void 0 ? _this$props$title : "Answer Feedback",
        isOpen: this.props.show,
        onRequestClose: function onRequestClose() {
          if (new Date() - _this.timeShowed > 100) {
            _this.props.onHide();
          }
        },
        actions: [/*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
          style: {
            height: "36px",
            marginTop: "4px",
            border: "2px solid transparent"
          },
          key: "close",
          variant: "solid",
          color: "primary",
          onClick: this.props.onHide
        }, this.props.buttonText || (correct || this.props.noRetry || info ? "Close" : "Try Again"))]
      }, !info && /*#__PURE__*/_react.default.createElement(_DesignComponents.Callout, {
        className: "answer-callout",
        style: {
          marginLeft: "1rem",
          marginRight: "1rem"
        },
        border: "left",
        color: correct ? "success" : "error"
      }, /*#__PURE__*/_react.default.createElement("b", null, "Your answer is ", correct ? "correct!" : "incorrect."), /*#__PURE__*/_react.default.createElement(_CompletionStatusContext.default.Consumer, null, function (_ref) {
        var pageCompleted = _ref.pageCompleted,
          interactiveCompleted = _ref.interactiveCompleted;
        return pageCompleted ? /*#__PURE__*/_react.default.createElement("b", null, " You have completed this step.") : "";
      })), /*#__PURE__*/_react.default.createElement("p", {
        style: {
          marginLeft: "1rem",
          marginRight: "1rem",
          lineHeight: "1.5"
        }
      }, this.props.children || (correct ? "Correct!" : "Incorrect. ".concat(this.props.noRetry ? "" : "Please try again."))));
    }
  }]);
  return ModalFeedback;
}(_react.Component);